import styled from 'styled-components'
import { primaryColor } from 'style/_variables.js'
import { Col } from 'react-flexbox-grid'

//import { Text } from 'components/forms'

export const StyledLabesStatus = styled.small`
	color: ${({ color, theme }) => theme[color]};
`

export const StyleParagraphStatus = styled.p`
	color: ${({ color, theme }) => theme[color]};
	font-size: ${({ fontSize }) => fontSize ? `${fontSize}em` : '1.1em'};
	margin-left: 10px;
`

export const StyledStatus = styled.span`
	display: inline-flex;
	align-items: center;
	margin-left: 0;
	&::before {
		content: '${({ connect }) => (connect ? '●' : '✖')}';
		margin-right: 3px;
		font-size: 0.8em;
	}
	& span {
		color: ${primaryColor};
		margin-left: 10px;
		font-weight: lighter;
	}
`

export const TseNotificationsTitle = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.fieldLabelColor || '#555'};
	margin-bottom: 6px;
`

export const TseNotificationsText = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.fieldLabelColor || '#555'};
	line-height: 1.5;
	overflow-wrap: anywhere;
	& + & {
		margin-top: 8px;
	}
`

// styles for Col with Checkbox center alignment
// when we have Select in the same row
export const StyledColAlignCenter = styled(Col)`
	height: 36px;
	align-self: flex-end;
	display: flex;
	align-items: center;
	&.colWithMenyCheckboxes{
		align-self: center;
		justify-content: space-between;
	}
	${({ $centerCheckboxLabel }) => (
	$centerCheckboxLabel
		? `
			label {
				align-items: center;
			}
		`
		: ''
)}
`
